module.exports = require("@braintree/sanitize-url");